import {
	ExperienceTypes,
	ExperiencePerformanceTypes,
	UFOExperience,
	useUFOComponentExperience,
} from '@atlassian/ufo';
import {
	EXTERNAL_RESOURCES_ADD_UPDATE_EXPERIENCE_ID,
	EXTERNAL_RESOURCES_DELETE_EXPERIENCE_ID,
	EXTERNAL_RESOURCES_REORDER_EXPERIENCE_ID,
} from './common/constants';

export interface UFOProductExperienceProps {
	ufoExperience: UFOExperience;
}

export const ProductExperienceStart: React.FunctionComponent<UFOProductExperienceProps> = (
	props,
) => {
	const { ufoExperience } = props;
	useUFOComponentExperience(ufoExperience);
	return null;
};

export const externalResourcesDeleteExperience = new UFOExperience(
	EXTERNAL_RESOURCES_DELETE_EXPERIENCE_ID,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const externalResourcesAddUpdateExperience = new UFOExperience(
	EXTERNAL_RESOURCES_ADD_UPDATE_EXPERIENCE_ID,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const externalResourcesReorderExperience = new UFOExperience(
	EXTERNAL_RESOURCES_REORDER_EXPERIENCE_ID,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

const markExperienceFailed = (experience: UFOExperience, error: Error) => {
	externalResourcesAddUpdateExperience.failure({
		force: true,
		metadata: {
			error: error.message,
		},
	});
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markDeleteExperienceFailed = (location: any, error: Error) => {
	markExperienceFailed(externalResourcesDeleteExperience, error);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAddUpdateExperienceFailed = (location: any, error: Error) => {
	markExperienceFailed(externalResourcesAddUpdateExperience, error);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markReorderExperienceFailed = (location: any, error: Error) => {
	markExperienceFailed(externalResourcesReorderExperience, error);
};
